import * as React from 'react';

import { LocalizedComponentProps } from 'bernie-l10n';

import { Experiment, ExperimentControl, ExperimentVariant } from '@shared-ui/experiment-context';

import { RadioGroup } from './radio-group';
import { RadioGroupProps } from 'components/common/search-form/fields/radio-group';
import { SearchFormFieldProps } from 'components/common/search-form/index';
import { SelectField } from './select-field';

export const SortExperiment: React.SFC<LocalizedComponentProps & SearchFormFieldProps & RadioGroupProps> = props => (
  <Experiment name="PWA_SORT_TNL_THROTTLE">
    <ExperimentControl>
      <Experiment name="PWA_Redesign_Sort_and_Filter_Phase_1">
        <ExperimentControl>
          <RadioGroup {...props} />
        </ExperimentControl>
        <ExperimentVariant bucket={1}>
          <SelectField {...props} />
        </ExperimentVariant>
      </Experiment>
    </ExperimentControl>
    <ExperimentVariant bucket={1}>
      <RadioGroup {...props} />
    </ExperimentVariant>
  </Experiment>
);
